export default __webpack_public_path__ + "3a88f7352b0d2d2722957951ca0be350.svg";